import { useState } from "react";
import star from "../assets/images/navbar/star.png";
import orangeStar from "../assets/images/navbar/orange-star.png";

type Props = {
  image: string;
  itemName: string;
  time: string;
  ratting: number;
};


const CustomerRattingCard = ({ image, itemName, time, ratting }: Props) => {
  return (
    <div className="py-[8px] border-b last:border-b-0 dark:border-gray-700">
      <div className="flex justify-between items-center">
        <div className="flex gap-[9px] items-center">
          <div className="flex items-center gap-4">
            <img
              src={image}
              alt="Food Item"
              className="h-[75px] w-[75px] rounded-[12px]"
            />
          </div>
          <div>
            <p className="text-[#050505] dark:text-gray-200 font-Urbanist text-[16px] font-medium leading-[23px]">
              {itemName}
            </p>

            <p className="text-[#6A6A6A] dark:text-gray-400 font-Urbanist text-[12px] font-normal leading-[20px]">
              Delivered {time}
            </p>
          </div>
        </div>

        <div className="flex gap-1">
          {Array.from({ length: 5 }, (_, index) => (
            <img
              key={index}
              src={index < ratting ? orangeStar : star}
              alt={index < ratting ? "filled star" : "empty star"}
              className={`h-[20px] w-[20px] ${index < ratting ? "" : "dark:invert"}`}
            />
          ))}
        </div>
      </div>
    </div>

  );
};

export default CustomerRattingCard;
